import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class SnapToZoomLevelButton extends PureComponent {
  static propTypes = {
    zoomLevel: PropTypes.string.isRequired,
    onSnapToZoomLevel: PropTypes.func.isRequired
  }

  render() {
    return (
      <div
        className={'control ' + this.props.zoomLevel}
        onClick={this.handleSnapToZoomLevel}
        title={'Snap to ' + this.props.zoomLevel}
      >
        <span className="label">{this.props.zoomLevel}</span>
      </div>
    )
  }

  handleSnapToZoomLevel = () => {
    this.props.onSnapToZoomLevel(this.props.zoomLevel)
  }
}
